import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreSearchApiUrlPrefix } from 'library-@/config/constants';
import type { ApiGetHiroBasicResponse, GetHiroBasic } from './get-hiro-basic-api.interface';
import type { GetFilterInfoRequest, GetFilterInfosResponse, GetSmartFilterResults } from './get-smart-filter-results.interface';

@injectable()
export class HiroBasicApiServiceImpl extends PsHttpService
    implements
        GetHiroBasic,
        GetSmartFilterResults {

    private _hiroBasicPromise: Promise<ApiGetHiroBasicResponse> | null = null;

    get options() {
        return {
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getHiroBasic(): Promise<ApiGetHiroBasicResponse> {
        if (!this._hiroBasicPromise) {
            this._hiroBasicPromise = this.get({
                url: `${coreSearchApiUrlPrefix}/chat/init`,
            }).then(res => res.data);
        }
        return this._hiroBasicPromise;
    }

    async getSmartFilterInfos(req: GetFilterInfoRequest): Promise<GetFilterInfosResponse> {
        if (req.filter_ids.length === 0) {
            return {};
        }

        const result = await this.get<PatSnapSuccessResponseData<GetFilterInfosResponse>>({
            url: `${coreSearchApiUrlPrefix}/agent/filter-v2/${req.filter_ids.join(',')}`,
        });
        return result.data;
    }
}
